module.exports = __webpack_public_path__ + "media/images/pc/top/recommend-plan-wedding4-778c3a8a5e9110dee356f6207f3e134e.jpg";